export const ONBOARDING_STATUS = 'onBoarding';
export const VERIFY_STATUS = 'verify';
